import { ClientInstallationStatusEnum } from '@api/enum/client-installation.enum';
import { IBusinessDevelopmentUser, IClientInstallation, IClientInstallationStatusCounter } from '@api/models';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAllClientInstallation = async () => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/client-installations`
    );
    // const data = clientInstallations;
    return data as IClientInstallation[];
};

export const getClientInstallationById = async (clientInstallationId: string) => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}`
    );

    return data as IClientInstallation;
};

export const addClientInstallation = async (payload: any) => {
    const { data, status } = await http.post(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/client-installations`,
        payload
    );
    return { data, status };
};

export const updateClientInstallation = async (clientInstallationId: string, payload: any) => {
    const { data } = await http.put(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}`,
        payload
    );
    return data as IClientInstallation;
};

export const getAllBusinessDevelopmentUsers = async () => {
    const { data } = await http.get(`${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/business-users`);

    return data as IBusinessDevelopmentUser[];
};

export const updateFileClientInstallation = async (clientInstallationId: string, payload: any) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/files`,
        payload
    );
    return data as IClientInstallation;
};
export const removeFileClientInstallation = async (clientInstallationId: string, fileId: string) => {
    const { data } = await http.delete(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/files/${fileId}`
    );
    return data as IClientInstallation;
};

export const getClientInstallationStatusCount = async (status: ClientInstallationStatusEnum) => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/client-installations/count?status=${status}`
    );
    // const data = dummyProjectInstallations;

    return data as IClientInstallationStatusCounter;
};
